<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        Wowza 서버 관리
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템관리 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/wowza/wowzaservers_list">Wowza 서버 관리</a>
      </div>

    </div>

    <v-row>
      <v-col cols="5">
        <SearchTextfield :search="searchQuery" placeholder="이름 또는 IP로 서버 찾기" />
      </v-col>

      <v-col class="text-right mb-2">
        <IconButton icon="mdi mdi-autorenew" small @click="refresh" class="mr-2" />
        <TextButton buttonText="활성화" :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 1)"
          class="mr-2" @click="wowzaServerStatusOnChange" />
        <TextButton buttonText="비활성화" class="mr-2"
          :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 0)"
          @click="wowzaServerStatusOffChange" />

        <IconButton icon="mdi-trash-can-outline"
          :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 1)" @click="wowzaServerDelete"
          class="mr-2" small />

        <!-- <router-link to="/wowza/wowzaservers_create"> -->
        <TextButton buttonText="서버 추가" isPrimary icon="mdi-plus" @click="openModal" />



      </v-col>
    </v-row>


    <!--table card-->
    <v-data-table :headers="headers" :items="wowzaServersItem" :items-per-page="10"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" loading-text="Loading data"
      :key="wowzaServersItem.id" :search="searchQuery" :loading="loading" class="data-table" :disable-sort="true"
      show-select v-model="selected">

      <template v-slot:item.is_enabled="{ item }">
        <div v-if="item.is_enabled === 1" style="color: #388E3C;">
          <v-icon class="mdi mdi-check-circle-outline mb-1 mr-1" small color="#388E3C"></v-icon><b>활성화</b>
        </div>
        <div v-else-if="item.is_enabled === 0" style="color: #989898;">
          <v-icon class="mdi mdi-dots-horizontal-circle-outline mb-1 mr-1" small color="#989898"></v-icon><b>비활성화</b>
        </div>

      </template>

    </v-data-table>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <!--라이브 생성 modal-->
    <AppDialog :value="modalOpen" @input="modalOpen = $event">
      <template v-slot:title>
        서버 추가
      </template>

      <template v-slot:content>
        <div class="suport_box">
          원하는 <strong>서비스 타입</strong>을 선택해주세요.
        </div>
        <v-btn-toggle v-model="serviceType" borderless class="mb-2" style="width: 50%;height: 40px;">
          <v-btn block height="40px" style="border: 1px solid #bbb;" value="VOD">
            <span class="hidden-sm-and-down">VOD</span>
          </v-btn>

          <v-btn block height="40px" style="border: 1px solid #bbb;" value="LIVE">
            <span class="hidden-sm-and-down">LIVE</span>
          </v-btn>
        </v-btn-toggle>

        <v-row>

          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">이름</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="name" :rules="nameRule" ref="nameInput" :counter="10" placeholder="이름" />
              <AppInputAlert :message="message" :message-type="messageType" class="mb-5"></AppInputAlert>
            </v-form>
          </v-col>

          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">아이피</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="ip" ref="ipInput" placeholder="아이피" />
            </v-form>
          </v-col>

          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">포트</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="port" ref="portInput" id="myInput" placeholder="포트" />
            </v-form>
          </v-col>

        </v-row>
      </template>
      <template v-slot:actions>
        <TextButtonBlock buttonText="취소" @click="closeModal" />
        <TextButtonBlock buttonText="저장" isPrimary @click="addServer" />
      </template>
    </AppDialog>


  </div>
</template>

<script>
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
// import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import WowzaServerApi from "@/api/wowzaserver/WowzaServerApi";
import SearchTextfield from '@/components/app/AppSearchField.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppDialog from '@/components/app/AppDialog.vue';
import FormInput from '@/components/ui/form/FormInput.vue';
import { mapState } from 'vuex';
import AppInputAlert from '@/components/app/AppInputAlert.vue';


export default {
  components: {
    TextButton,
    IconButton,
    TextButtonBlock,
    SearchTextfield,
    AppSnackbar,
    AppDialog,
    FormInput,
    AppInputAlert
  },
  data() {
    return {
      headers: [
        { text: '이름', value: 'name' },
        { text: '아이피', value: 'ip' },
        { text: '생성날짜', value: 'created_at' },
        { text: 'checked_at', value: 'checked_at' },
        { text: '상태', value: 'is_enabled' },
        { text: '서비스', value: 'service' },
      ],
      wowzaServersItem: [],
      selected: [],
      search: '',
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      modalOpen: false,
      name: '',
      ip: '',
      port: '',
      valid: true,
      serviceType: 'VOD',
      nameRule: [
        v => !!v || 'Name is required',
        v => /^[a-zA-Z][a-zA-Z0-9]*$/.test(v) || 'Must start with a letter and can use letters and numbers',
        v => v && v.length >= 2 && v.length <= 50 || 'Name must be between 2 and 50 characters',
      ],
      ipRule: [
        v => !!v || "IP Address is required",
        v =>
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
            v
          ) || "IP Address is invalid",
      ],
      portRule: [
        (v) => !!v || "Port is required",
        (v) => /^\d+$/.test(v) || "Port must be a number",
        (v) => v >= 0 && v <= 65535 || "Port must be between 0 and 65535",
      ],
      message: '',
      messageType: '',
    }
  },
  computed: {
    ...mapState('search', ['searchQuery']),
  },
  mounted() {
    this.wowzaServerList();
  },
  methods: {
    async wowzaServerList() {
      try {
        this.loading = true;
        const response = await WowzaServerApi.listApi();
        this.loading = false;
        this.wowzaServersItem = response.wowzaServers;
      } catch (error) {
        console.error('error', error);
      }
    },
    async wowzaServerDelete() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 1)) {
        this.loading = true;
        const data = {
          serverIds: this.selected.map(server => server.id)
        };
        try {
          const response = await WowzaServerApi.deleteApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '삭제 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.wowzaServerList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '삭제 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '삭제 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    },
    async wowzaServerStatusOffChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 0)) {
        this.loading = true;

        const data = {
          ids: this.selected.map(server => server.id),
          is_enabled: "0"
        };
        try {
          const response = await WowzaServerApi.statusChangeApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.wowzaServerList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '변경 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '변경 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    },
    async wowzaServerStatusOnChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 1)) {
        this.loading = true;
        const data = {
          ids: this.selected.map(server => server.id),
          is_enabled: "1"
        };
        try {
          const response = await WowzaServerApi.statusChangeApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.wowzaServerList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '변경 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '변경 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);

    },
    async refresh() {
      this.wowzaServerList();
    },
    openModal() {
      this.modalOpen = true;
    },
    async addServer() {

      if (!this.name) {
        // this.message = '이름을 입력해주세요.';
        // this.messageType = 'warning';
        this.setMessage('이름을 입력해주세요.', 'warning');

        return;
      }

      if (!this.ip) {
        // this.message = '아이피를 입력해주세요.';
        // this.messageType = 'warning';
        this.setMessage('아이피를 입력해주세요.', 'warning');

        return;
      }

      if (!this.port) {
        // this.message = '포트를 입력해주세요.';
        // this.messageType = 'warning';
        this.setMessage('포트를 입력해주세요.', 'warning');

        return;
      }

      const data = {
        name: this.name,
        ip: this.ip,
        port: this.port,
        type: this.serviceType
      }
      const response = await WowzaServerApi.addApi(data);
      if (response.status === 201) {
        this.modalOpen = false;
        this.snackbarText = '변경 성공';
        this.snackbarError = false;
        this.resetForm();
        this.wowzaServerList();
      } else {
        this.snackbarText = '변경 실패';
        this.snackbarError = false;
      }
    },
    setMessage(message, type) {
      this.message = message;
      this.messageType = type;
      setTimeout(() => {
        this.message = '';
        this.messageType = '';
      }, 5000);
    },
    resetForm() {
      this.name = '';
      this.port = '';
      this.ip = '';
      this.serviceType = '';
    },
    closeModal() {
      this.resetForm();
      this.modalOpen = false;
    }




  },

}
</script>

<style lang="scss" scoped></style>